import { css } from "@emotion/react";
import dayjs from "dayjs";
import { Link } from "react-router";
import { BookmarkButton } from "../../bits/bookmarks/BookmarkButton";
import {
  frjTagLink,
  frjArticleTitle,
  frjArticleExcerpt,
  frjArticleDate,
  frjArticleAuthor,
} from "../../bits/frjUtils";

export type Post = {
  title?: string;
  url?: string;
  published_at?: string | null;
  feature_image?: string | null;
  feature_image_alt?: string | null;
  primary_author?: { name?: string } | null;
  excerpt?: string | null;
  slug: string;
  tags?: { name?: string; id: string; slug: string }[];
};

export type Tag = "cases" | "blog" | "journal";

export const ArticleCard = ({
  post,
  tagGroup,
}: {
  post: Post;
  tagGroup: Tag;
}) => {
  const url = `/article/${post.slug}`;
  return (
    <div
      css={css`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        `}
      >
        {post?.tags?.map((tag, index) => {
          if (!tag.name) return null;
          if (index > 5) return null;
          if (tag.name.startsWith("#")) return null;
          if (tag.name.toLowerCase() === tagGroup) return null;
          return (
            <Link to={`/frj/tag/${tag.slug}`} css={frjTagLink} key={tag.id}>
              {tag.name}
            </Link>
          );
        })}
      </div>
      <Link
        to={url}
        css={css`
          display: flex;
          gap: 16px;
          text-decoration: none;
          border-radius: 8px;
          transition: opacity 0.15s ease;
          &:hover {
            opacity: 0.8;
          }
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
            gap: 4px;
            min-width: 0;
          `}
        >
          <h3 css={frjArticleTitle}>{post.title}</h3>
          {post.excerpt && <p css={frjArticleExcerpt}>{post.excerpt}</p>}
        </div>
      </Link>
      <div
        css={css`
          display: flex;
          justify-content: space-between;
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
          `}
        >
          {post.published_at && (
            <time
              dateTime={dayjs(post.published_at).format("YYYY-MM-DD")}
              css={frjArticleDate}
            >
              {dayjs(post.published_at).format("DD MMM YYYY")}
            </time>
          )}
          {post.primary_author?.name && (
            <span css={frjArticleAuthor}>{post.primary_author.name}</span>
          )}
        </div>
        <BookmarkButton
          sectionId={`${post.slug}-ch:0`}
          articleSlug={post.slug || ""}
          sectionLabel={post.title || ""}
          contents={[{ id: "123", type: "chapter", label: post.title || "" }]}
        />
      </div>
    </div>
  );
};
